import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth, setPersistence, browserSessionPersistence, browserLocalPersistence } from 'firebase/auth'

const firebaseConfig = {
    apiKey: "AIzaSyBAVts94tOddTup8Nn1_7iAp3GKD7e3Gaw",
    authDomain: "privatecandidateportal.firebaseapp.com",
    projectId: "privatecandidateportal",
    storageBucket: "privatecandidateportal.firebasestorage.app",
    messagingSenderId: "376032802524",
    appId: "1:376032802524:web:a15364a2d28674a8a1a619",
    measurementId: "G-9S4S1HQVSL"
};

const app = initializeApp(firebaseConfig)
//init firestore
//const projectFirestore = getFirestore()
const db = getFirestore()

//init fb auth

const auth = getAuth()
//setPersistence(auth, browserSessionPersistence)
setPersistence(auth, browserLocalPersistence)
const timestamp = db.Timestamp
export { db, auth, timestamp, app }
